module.exports = __webpack_public_path__ + "img/225.c592aa2c.jpg";